/* Andy Cooks – quick-add "+" on every product card (.acs-card): collection pages, "Get the gear" on recipe pages,
   "You might also like" on product pages, "Add something extra" on the cart page and anywhere else the cards show.
   Same look as the home page Shop row (.h3-p__plus). Styles: assets/ac-fixes.css (.acs-plus). Loaded from snippets/ac-fonts.
   Click: if the card's own "Add to cart" button is there and showing, the "+" presses it (same add + cart drawer);
   otherwise (options to choose, sold out, or adding switched off for this country) it opens the product page. */
(function () {
  if (window.__acQuickAdd) return;
  window.__acQuickAdd = true;
  var PLUS = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 6v12M6 12h12"/></svg>';
  function label(card) {
    var t = card.querySelector('.acs-card__t');
    var name = t ? t.textContent.trim() : '';
    var base = (window.AC_I18N && window.AC_I18N['ac.js.shop.quick_add']) || 'Quick add';
    return name ? base + ': ' + name : base;
  }
  function setup(card) {
    if (card.querySelector('.acs-plus') || card.closest('.h3-p')) return;
    var media = card.querySelector('.acs-card__media');
    if (!media) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'acs-plus';
    b.setAttribute('aria-label', label(card));
    b.innerHTML = PLUS;
    media.insertAdjacentElement('afterend', b);
  }
  function scan(root) {
    (root || document).querySelectorAll('.acs-card').forEach(setup);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.acs-plus');
    if (!b) return;
    e.preventDefault();
    var card = b.closest('.acs-card');
    var add = card && card.querySelector('.acs-card__btn[data-acs-add]');
    if (add && getComputedStyle(add).display !== 'none') { add.click(); return; }
    var link = card && card.querySelector('.acs-card__media, .acs-card__t a');
    if (link && link.href) window.location = link.href;
  });
  function start() {
    scan();
    if (window.MutationObserver) {
      new MutationObserver(function (list) {
        for (var i = 0; i < list.length; i++) {
          for (var j = 0; j < list[i].addedNodes.length; j++) {
            var n = list[i].addedNodes[j];
            if (n.nodeType !== 1) continue;
            if (n.classList && n.classList.contains('acs-card')) setup(n); else if (n.querySelector && n.querySelector('.acs-card')) scan(n);
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
